module.exports = __webpack_public_path__ + "static/media/feature4.5b6d79cf.png";